import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { DateUtil } from '../../utils/date-util';

import * as lodash from 'lodash';
// import * as moment from 'moment';
import moment from 'moment'

@Component({
    selector: 'app-content-date-picker',
    templateUrl: './content-date-picker.component.html',
    styleUrls: ['./content-date-picker.component.scss']
})
export class ContentDatePickerComponent implements OnInit {

    @Output() getDateFromDatePicker: EventEmitter<object> = new EventEmitter<object>();

    datePicker: any = {
        values: [
        ],
        selected_index: 0,
        has_previous: false,
        has_next: false
    };

    ngOnInit() {
        this.initComponent(3);
        this.getActualDate();
        this.getRangeOfDates();
    }

    /**
     * Display component with preload data N months before
     * @param months_before 
     */
    initComponent(months_before: number) {
        let dateArray = [];
        let quantity_to_substract = 0;

        moment.locale('es');

        while (quantity_to_substract < months_before) {
            let date = moment().subtract(quantity_to_substract, 'months');
            dateArray.push({
                value: date.format('YYYY-MM'),
                date: date.format('MMMM YYYY')
            });
            quantity_to_substract++;
        }
        this.datePicker.values = lodash.reverse(dateArray);
    }

    /** 
     * Get actual date
    */
    getActualDate() {
        const actualValue = DateUtil.getActualDate('YYYY-MM');
        const actualIndex = lodash.findIndex(this.datePicker.values, { value: actualValue });
        const selectedIndex = this.datePicker.selected_index = actualIndex;
    }

    /** 
     * Get range of dates
    */
    getRangeOfDates() {
        const selectedDateString = this.datePicker.values[this.datePicker.selected_index].value;
        const splitDate = selectedDateString.split('-');
        const datesRange = DateUtil.getMonthRangeDates(Number(splitDate[0]), Number(splitDate[1]), 'YYYY-MM-DD');
        this.checkNextAndPreviousDate();
        this.getDateFromDatePicker.emit(datesRange);
    }

    /** 
     * Get previous date
    */
    previousDate() {
        this.datePicker.selected_index =
            (typeof this.datePicker.values[this.datePicker.selected_index - 1] === 'undefined') ? false : this.datePicker.selected_index -= 1;
        this.getRangeOfDates();
    }

    /** 
     * Get next date
    */
    nextDate() {
        this.datePicker.selected_index =
            (typeof this.datePicker.values[this.datePicker.selected_index + 1] === 'undefined') ? false : this.datePicker.selected_index += 1;
        this.getRangeOfDates();
    }

    /** 
     * Check next and previous date
    */
    checkNextAndPreviousDate() {
        this.datePicker.has_next = (typeof this.datePicker.values[this.datePicker.selected_index + 1] === 'undefined') ? false : true;
        this.datePicker.has_previous = (typeof this.datePicker.values[this.datePicker.selected_index - 1] === 'undefined') ? false : true;
    }

}
